export const VAT_PERCENTAGE = 0.2
export const VAT_EXCLUSION_FACTOR = 0.8
export const VAT_INCLUSION_FACTOR = 1.25